(function() {
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      if (this.timer) clearInterval(this.timer);
      this.timerElement = this.querySelector('.countdown-timer');
      this.expiredElement = this.querySelector('.countdown-expired');
      this.units = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector('[data-' + unit + ']'));
      this.duration = this.dataset.repeatHours === '6' ? 21600000 : 0;
      this.storageKey = 'kbs-countdown-six-hours:' + (this.dataset.timerKey || 'default');
      this.endDate = new Date(this.dataset.endDate).getTime();
      if (this.duration) {
        let saved;
        try { saved = Number(localStorage.getItem(this.storageKey)); } catch (error) {}
        this.endDate = Number.isFinite(saved) && saved > 0 && saved <= Date.now() + this.duration ? saved : Date.now() + this.duration;
        this.saveEndDate();
      }
      this.onVisibility = () => { if (!document.hidden) this.updateCountdown(); };
      document.addEventListener('visibilitychange', this.onVisibility);
      this.timer = setInterval(() => this.updateCountdown(), 1000);
      this.updateCountdown();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      this.timer = null;
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    saveEndDate() {
      try { localStorage.setItem(this.storageKey, String(this.endDate)); } catch (error) {}
    }

    updateCountdown() {
      const now = Date.now();
      if (this.duration && this.endDate <= now) {
        this.endDate += (Math.floor((now - this.endDate) / this.duration) + 1) * this.duration;
        this.saveEndDate();
      }
      const distance = this.endDate - now;
      if (!Number.isFinite(distance) || distance < 0) {
        clearInterval(this.timer);
        this.timer = null;
        if (this.timerElement) this.timerElement.style.display = 'none';
        if (this.expiredElement) this.expiredElement.style.display = 'block';
        return;
      }
      if (this.timerElement) this.timerElement.style.display = '';
      if (this.expiredElement) this.expiredElement.style.display = 'none';
      const totalSeconds = Math.ceil(distance / 1000);
      const values = [Math.floor(totalSeconds / 86400), Math.floor(totalSeconds / 3600) % 24, Math.floor(totalSeconds / 60) % 60, totalSeconds % 60];
      this.units.forEach((element, index) => { if (element) element.textContent = String(values[index]).padStart(2, '0'); });
    }
  }
  if (!customElements.get('countdown-timer')) customElements.define('countdown-timer', CountdownTimer);
})();

